import React, { useState } from 'react';
import './Notifications.css';
import { sendNotification } from '../../services/NotificationService.ts';
import Form from '../../coreComponents/Form/Form.tsx';
import { Snackbar, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Button from '../../coreComponents/Button/Button.tsx';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NotificationCreate = () => {
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const navigate = useNavigate();

  const handleAfterSend = () => {
  };

  return (
    <div className="notifications-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
      <ArrowBackIcon onClick={() => navigate('/notifications')} style={{ position: 'absolute', left: 16, top: 0, cursor: 'pointer', fontSize: 32, color: '#4a5568' }} />
      <div style={{ display: 'flex', gap: 32, marginBottom: 32, marginTop: 32 }}>
        <NotificationCard entityType="User" label="Mapto" setSnackbar={setSnackbar} afterSend={handleAfterSend} />
        <NotificationCard entityType="Driver" label="Mapto Driver" setSnackbar={setSnackbar} afterSend={handleAfterSend} />
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          severity={snackbar.severity as 'success' | 'error' | 'info' | 'warning'}
          sx={{ width: '100%', backgroundColor: snackbar.severity === 'success' ? '#43a047' : undefined, color: snackbar.severity === 'success' ? '#fff' : undefined }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

const NotificationCard = ({ entityType, label, setSnackbar, afterSend }) => {
  const [loading, setLoading] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const initialValues = { title: '', body: '', entityId: '' };

  const fields = [
    { type: 'text', name: 'title', label: 'Title', placeholder: 'Title', required: true },
    { type: 'textarea', name: 'body', label: 'Body', placeholder: 'Body', required: true },
    { type: 'number', name: 'entityId', label: `${entityType} ID (optional)`, placeholder: `${entityType} ID (optional)` },
  ];

  const handleSubmit = async (values) => {
    if (!values.title || !values.body) {
      setSnackbar({ open: true, message: 'Title and Body are required.', severity: 'error' });
      return;
    }
    setLoading(true);
    try {
      await sendNotification({
        entityType,
        title: values.title,
        body: values.body,
        ...(values.entityId && { entityId: Number(values.entityId) })
      });
      setSnackbar({ open: true, message: 'Notification sent!', severity: 'success' });
      setFormKey(prev => prev + 1); // Reset form
      if (afterSend) afterSend();
    } catch (e) {
      setSnackbar({ open: true, message: 'Failed to send notification.', severity: 'error' });
    }
    setLoading(false);
  };

  return (
    <div className="notification-card">
      <h3 className="notification-title">{label}</h3>
      <Form
        key={formKey}
        fields={fields}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        onCancel={() => {}}
        buttons={[{
          id: 'send',
          children: loading ? 'Sending...' : 'Send',
          type: 'submit',
          variant: 'contained',
          fullWidth: true
        }]}
      />
    </div>
  );
};

export default NotificationCreate;
